import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';
import FormDatosEmail from './FormDatosEmail';
import { withApollo, graphql, compose } from 'react-apollo';

import enviarDocumentoPorEmail from '../../../graphql/mutations/common/enviarDocumentoPorEmail.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsExpedientes from '../../../actions/expediente';
import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';

@compose(
  graphql(getOrganismos, {
    name: 'getOrganismos',
  }),
  graphql(enviarDocumentoPorEmail, { name: 'enviarDocumentoPorEmail' })
)
class ModalMandarEmail extends Component {
  state = {
    articulosParaSancionar: [],
    cantidadJus: 0,
    montoSancion: 0,
    montoAdicional: 0,
  };

  handleOk = datos => {
    const emailDestino = datos.emailDestino.includes('@') 
    ? datos.emailDestino 
    : `${datos.emailDestino}@jusneuquen.gov.ar`;

    this.props
      .enviarDocumentoPorEmail({
        variables: {
          _id: this.props.idDocumento,
          emailDestino: emailDestino,
          cuerpo: datos.cuerpo,
        },
      })
      .then(res => {
        if (res) {
          notification.success({
            message: 'El email se ha enviado correctamente.',
          });

          this.props.ocultarModalMandarEmail();
        } else {
          notification.error({
            message: 'Error a la hora de enviar el email, intente nuevamente.',
          });
        }
      })
      .catch(err => {
        console.log('ERROR AL ENVIAR EL EMAIL: ', err);
        notification.error({
          message: 'Error a la hora de enviar el email, intente nuevamente.',
        });
      });
  };

  render() {
    let organismos = this.props.getOrganismos.getOrganismos;
    if (organismos && !organismos.length) {
      return null;
    }
    return (
      <div>
        <Modal
          title="Enviar Documento por Email"
          visible={this.props.visibleModalMandarEmail}
          onCancel={this.props.ocultarModalMandarEmail}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormDatosEmail onSubmit={this.handleOk} organismos={organismos} />
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(ModalMandarEmail));
